import { Reducer } from 'redux';
import { BookingsInsightsReportState, BookingsInsightsReportStatus } from './BookingsInsightsReportState';
import { BookingsInsightsReport } from 'model/BookingsReport';
import {
    BOOKINGS_INSIGHTS_REPORT_GET_START,
    BOOKINGS_INSIGHTS_REPORT_GET_SUCCESS,
    BOOKINGS_INSIGHTS_REPORT_GET_ERROR,
    BookingsInsightsReportAction
} from 'actions/insights/bookings/bookingsInsights/BookingsInsightsReportActionsTypes';

const emptyBookingInsights: BookingsInsightsReport = {
    totalAppointments: 0,
    totalUpcoming: 0,
    percentUpcoming: 0,
    totalCompleted: 0,
    percentCompleted: 0,
    totalCancelled: 0,
    percentCancelled: 0,
    totalNoShow: 0,
    percentNoShow: 0,
    totalOnlineBooking: 0,
    percentOnlineBooking: 0,
    totalBusinessBooked: 0,
    percentBusinessBooked: 0,
    totalNewClients: 0,
    percentNewClients: 0,
    totalReturningClients: 0,
    percentReturningClients: 0
};

const initialState: BookingsInsightsReportState = {
    insights: emptyBookingInsights,
    status: BookingsInsightsReportStatus.Initial,
    loading: false
};

export const BookingsInsightsReportReducer: Reducer<BookingsInsightsReportState, BookingsInsightsReportAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case BOOKINGS_INSIGHTS_REPORT_GET_START:
            return {
                ...state,
                status: BookingsInsightsReportStatus.Getting,
                loading: true
            };
        case BOOKINGS_INSIGHTS_REPORT_GET_SUCCESS:
            return {
                ...state,
                insights: action.payload.insights,
                status: BookingsInsightsReportStatus.GettingSuccess,
                loading: false
            };
        case BOOKINGS_INSIGHTS_REPORT_GET_ERROR:
            return {
                ...state,
                status: BookingsInsightsReportStatus.Error,
                loading: false
            };
        default:
            return state;
    }
};
